import styled from "styled-components"

export const FormSection = styled.div`
  margin-bottom: 2rem;
`

export const FormLabel = styled.label`
  display: block;
  font-size: 1.2rem;
  ${(p) => p.theme.bold};
  color: ${(p) => p.theme.colors.greyDarker};
  margin-bottom: 0.5rem;
`

export const SelectWrapper = styled.div`
  margin-bottom: 1.5rem;

  select {
    width: 100%;
    padding: 0.8rem 1rem;
    border: 0.1rem solid ${(p) => p.theme.colors.greyLight};
    border-radius: 0.4rem;
    font-size: 1.3rem;
    background: ${(p) => p.theme.colors.white};
  }
`

export const TextArea = styled.textarea`
  width: 100%;
  padding: 0.8rem 1rem;
  border: 0.1rem solid ${(p) => p.theme.colors.greyLight};
  border-radius: 0.4rem;
  font-size: 1.2rem;
  font-family: monospace;
  background: ${(p) => p.theme.colors.white};
  min-height: 12rem;
  resize: vertical;
  box-sizing: border-box;
`

export const HelperText = styled.div`
  background: ${(p) => p.theme.colors.greyLighter};
  border-radius: 0.4rem;
  padding: 1rem 1.2rem;
  font-size: 1.1rem;
  line-height: 1.6;
  color: ${(p) => p.theme.colors.greyDarker};
  margin-bottom: 1.5rem;

  strong {
    display: block;
    margin-bottom: 0.4rem;
    font-size: 1.2rem;
  }

  code {
    background: ${(p) => p.theme.colors.white};
    padding: 0.1rem 0.4rem;
    border-radius: 0.3rem;
    font-size: 1.1rem;
  }

  pre {
    background: ${(p) => p.theme.colors.white};
    padding: 0.8rem;
    border-radius: 0.3rem;
    font-size: 1rem;
    line-height: 1.4;
    overflow-x: auto;
    margin: 0.6rem 0;
    white-space: pre;
  }
`

export const ValueListRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.8rem;

  input {
    flex: 1;
    padding: 0.8rem 1rem;
    border: 0.1rem solid ${(p) => p.theme.colors.greyLight};
    border-radius: 0.4rem;
    font-size: 1.3rem;
    background: ${(p) => p.theme.colors.white};
  }
`

export const ValueInput = styled.input`
  width: 100%;
  padding: 0.9rem 1.2rem;
  border: 0.1rem solid ${(p) => p.theme.colors.greyLight};
  border-radius: 0.4rem;
  font-size: 1.3rem;
  font-family: inherit;
  background: ${(p) => p.theme.colors.white};
  color: ${(p) => p.theme.colors.black};
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  box-sizing: border-box;

  &::placeholder {
    color: ${(p) => p.theme.colors.greyDark};
    opacity: 0.7;
  }

  &:hover {
    border-color: ${(p) => p.theme.colors.greyDark};
  }

  &:focus {
    outline: none;
    border-color: ${(p) => p.theme.colors.turquoiseDark};
    box-shadow: 0 0 0 0.3rem ${(p) => p.theme.colors.turquoiseBorder};
  }
`

export const RemoveValueButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.4rem;
  color: ${(p) => p.theme.colors.greyDark};
  font-size: 1.6rem;
  line-height: 1;

  &:hover {
    color: ${(p) => p.theme.colors.errorText};
  }
`

export const AddValueButton = styled.button`
  background: none;
  border: 0.1rem dashed ${(p) => p.theme.colors.greyLight};
  border-radius: 0.4rem;
  padding: 0.6rem 1rem;
  font-size: 1.2rem;
  color: ${(p) => p.theme.colors.turquoiseDark};
  cursor: pointer;
  width: 100%;
  ${(p) => p.theme.bold};

  &:hover {
    border-color: ${(p) => p.theme.colors.turquoiseDark};
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`

export const DeleteNodeButton = styled.button`
  background: transparent;
  border: none;
  color: ${(p) => p.theme.colors.errorText};
  cursor: pointer;
  ${(p) => p.theme.bold};
  font-size: 1.3rem;
`

export const CheckboxRow = styled.label`
  display: flex;
  align-items: center;
  gap: 1rem;
  cursor: pointer;
  padding: 0.4rem 0;
  font-size: 1.3rem;
  color: ${(p) => p.theme.colors.black};

  input[type="checkbox"] {
    appearance: none;
    -webkit-appearance: none;
    width: 1.8rem;
    height: 1.8rem;
    border: 0.1rem solid ${(p) => p.theme.colors.greyLight};
    border-radius: 0.3rem;
    background: ${(p) => p.theme.colors.white};
    cursor: pointer;
    position: relative;
    flex-shrink: 0;
    margin: 0;
    transition: all 0.15s ease;

    &:hover {
      border-color: ${(p) => p.theme.colors.turquoiseDark};
    }

    &:checked {
      background: ${(p) => p.theme.colors.turquoiseDark};
      border-color: ${(p) => p.theme.colors.turquoiseDark};
    }

    &:checked::after {
      content: "";
      position: absolute;
      top: 0.1rem;
      left: 0.5rem;
      width: 0.4rem;
      height: 0.9rem;
      border: solid ${(p) => p.theme.colors.white};
      border-width: 0 0.2rem 0.2rem 0;
      transform: rotate(45deg);
    }
  }
`

export const GroupContainer = styled.div`
  border-left: 0.3rem solid ${(p) => p.theme.colors.turquoiseDark};
  background: ${(p) => p.theme.colors.greyLighter};
  border-radius: 0 0.4rem 0.4rem 0;
  padding: 1rem 1.2rem;
  margin-bottom: 1rem;
`

export const GroupHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.8rem;
  margin-bottom: 1rem;
`

export const OperatorToggle = styled.div`
  display: inline-flex;
  border: 0.1rem solid ${(p) => p.theme.colors.greyLight};
  border-radius: 0.4rem;
  overflow: hidden;
  background: ${(p) => p.theme.colors.white};
`

export const OperatorButton = styled.button<{ $active: boolean }>`
  background: ${(p) =>
    p.$active ? p.theme.colors.turquoiseDark : p.theme.colors.white};
  color: ${(p) =>
    p.$active ? p.theme.colors.white : p.theme.colors.greyDarker};
  border: none;
  padding: 0.5rem 1.4rem;
  font-size: 1.2rem;
  cursor: pointer;
  ${(p) => p.theme.bold};

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`

export const GroupChild = styled.div`
  background: ${(p) => p.theme.colors.white};
  border: 0.1rem solid ${(p) => p.theme.colors.greyLight};
  border-radius: 0.4rem;
  padding: 1rem 1.2rem;
  margin-bottom: 0.8rem;
  position: relative;
`

export const ChildHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.8rem;
  font-size: 1.1rem;
  color: ${(p) => p.theme.colors.greyDark};
`

export const ChildActions = styled.div`
  display: flex;
  gap: 0.6rem;
`

export const SmallActionButton = styled.button<{ $destructive?: boolean }>`
  background: none;
  border: 0.1rem solid
    ${(p) => (p.$destructive ? p.theme.colors.errorText : p.theme.colors.greyLight)};
  border-radius: 0.3rem;
  padding: 0.3rem 0.6rem;
  font-size: 1.1rem;
  color: ${(p) =>
    p.$destructive ? p.theme.colors.errorText : p.theme.colors.greyDarker};
  cursor: pointer;

  &:hover {
    border-color: ${(p) =>
      p.$destructive ? p.theme.colors.errorText : p.theme.colors.turquoiseDark};
    background: ${(p) =>
      p.$destructive ? p.theme.colors.errorText : "transparent"};
    color: ${(p) =>
      p.$destructive ? p.theme.colors.white : p.theme.colors.turquoiseDark};
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`

export const GroupActionsRow = styled.div`
  display: flex;
  gap: 0.6rem;
  margin-top: 0.4rem;
`

// ──────────────────────────────────────────────────────────────────────────
// Field-bag editor (set-field cards + add-field row)
// ──────────────────────────────────────────────────────────────────────────

export const FieldCard = styled.div`
  background: ${(p) => p.theme.colors.white};
  border: 0.1rem solid ${(p) => p.theme.colors.greyLight};
  border-radius: 0.6rem;
  padding: 1.2rem 1.4rem;
  margin-bottom: 1rem;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:focus-within {
    border-color: ${(p) => p.theme.colors.turquoiseDark};
    box-shadow: 0 0 0 0.3rem ${(p) => p.theme.colors.turquoiseBorder};
  }

  /* Tighten spacing for inputs nested in a field card. */
  ${SelectWrapper} {
    margin-bottom: 1rem;
  }
  ${FormSection} {
    margin-bottom: 1rem;

    &:last-child {
      margin-bottom: 0;
    }
  }
`

export const FieldCardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.8rem;
  margin-bottom: 0.8rem;
  padding-bottom: 0.8rem;
  border-bottom: 0.1rem solid ${(p) => p.theme.colors.greyLighter};
`

export const FieldCardTitle = styled.span`
  font-size: 1.25rem;
  ${(p) => p.theme.bold};
  color: ${(p) => p.theme.colors.greyDarker};
`

export const FieldRemoveIconButton = styled.button`
  background: transparent;
  border: 0.1rem solid transparent;
  color: ${(p) => p.theme.colors.greyDark};
  cursor: pointer;
  font-size: 1.4rem;
  line-height: 1;
  padding: 0.3rem 0.7rem;
  border-radius: 0.3rem;
  transition: all 0.15s ease;

  &:hover {
    background: ${(p) => p.theme.colors.errorText};
    color: ${(p) => p.theme.colors.white};
    border-color: ${(p) => p.theme.colors.errorText};
  }
`

export const FieldAdderRow = styled.div`
  display: flex;
  align-items: stretch;
  gap: 0.6rem;
  padding: 0.8rem;
  background: ${(p) => p.theme.colors.greyLighter};
  border: 0.1rem dashed ${(p) => p.theme.colors.greyLight};
  border-radius: 0.6rem;

  /* Direct child (the SingleSelect wrapper) takes the remaining space. */
  > :first-child {
    flex: 1;
    min-width: 0;
  }
`

export const FieldAdderButton = styled.button`
  background: ${(p) => p.theme.colors.turquoiseDark};
  color: ${(p) => p.theme.colors.white};
  border: none;
  border-radius: 0.4rem;
  padding: 0 1.4rem;
  font-size: 1.2rem;
  ${(p) => p.theme.bold};
  cursor: pointer;
  transition: opacity 0.15s ease;
  white-space: nowrap;

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`

export const EmptyFieldsHint = styled.div`
  background: ${(p) => p.theme.colors.greyLighter};
  border: 0.1rem dashed ${(p) => p.theme.colors.greyLight};
  border-radius: 0.6rem;
  padding: 1.4rem 1.6rem;
  margin-bottom: 1rem;
  font-size: 1.2rem;
  color: ${(p) => p.theme.colors.greyDarker};
  line-height: 1.5;
  text-align: center;
`

export const InlineError = styled.div`
  margin-top: 0.4rem;
  font-size: 1.1rem;
  color: ${(p) => p.theme.colors.errorText};
`

// ──────────────────────────────────────────────────────────────────────────
// Key/value pair card (ORDER_LINE customAttributes / tags / options)
// ──────────────────────────────────────────────────────────────────────────

export const KeyValueCard = styled.div`
  background: ${(p) => p.theme.colors.greyLighter};
  border: 0.1rem solid ${(p) => p.theme.colors.greyLight};
  border-radius: 0.5rem;
  padding: 1rem 1.2rem;
  margin-bottom: 0.8rem;
`

export const KeyValueCardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.8rem;
  font-size: 1.1rem;
  ${(p) => p.theme.bold};
  color: ${(p) => p.theme.colors.greyDark};
  text-transform: uppercase;
  letter-spacing: 0.05rem;
`

export const KeyValueSubsection = styled.div`
  background: ${(p) => p.theme.colors.white};
  border: 0.1rem solid ${(p) => p.theme.colors.greyLight};
  border-radius: 0.4rem;
  padding: 0.8rem 1rem;
  margin-bottom: 0.6rem;

  &:last-child {
    margin-bottom: 0;
  }
`

export const KeyValueSubsectionLabel = styled.div`
  font-size: 1.1rem;
  ${(p) => p.theme.bold};
  color: ${(p) => p.theme.colors.greyDarker};
  margin-bottom: 0.6rem;
`

export const ValidationProblems = styled.div`
  background: ${(p) => p.theme.colors.errorBackground ?? "#fff5f5"};
  border: 0.1rem solid ${(p) => p.theme.colors.errorText};
  border-radius: 0.5rem;
  padding: 1rem 1.2rem;
  margin-top: 1.5rem;
  font-size: 1.2rem;
  color: ${(p) => p.theme.colors.errorText};
  line-height: 1.5;

  strong {
    display: block;
    margin-bottom: 0.5rem;
    ${(p) => p.theme.bold};
  }
`

export const ValidationProblemsList = styled.ul`
  margin: 0;
  padding-left: 1.8rem;

  li {
    margin-bottom: 0.3rem;

    &:last-child {
      margin-bottom: 0;
    }
  }
`

export const ReadOnlyFieldset = styled.fieldset`
  border: none;
  padding: 0;
  margin: 0;
`

export const SaveButton = styled.button`
  width: 100%;
  padding: 1rem;
  background: ${(p) => p.theme.colors.turquoiseDark};
  color: ${(p) => p.theme.colors.white};
  border: none;
  border-radius: 0.4rem;
  font-size: 1.4rem;
  cursor: pointer;
  ${(p) => p.theme.bold};
  margin-top: 2rem;
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 0.9;
  }
`
